


export class PersonalNumberVendor {
  "personalNumber";
  "name";
  "vendor";
  "coCd";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PersonalNumberVendor`.
   */
  static getModelName() {
    return "PersonalNumberVendor";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PersonalNumberVendor for dynamic purposes.
  **/
  static factory(data) {
    return new PersonalNumberVendor(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'PersonalNumberVendor',
      plural: 'PersonalNumberVendors',
      path: 'PersonalNumberVendors',
      properties: {
        "personalNumber": {
          name: 'personalNumber',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "vendor": {
          name: 'vendor',
          type: 'string'
        },
        "coCd": {
          name: 'coCd',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/PersonalNumberVendor.js